// extracted by mini-css-extract-plugin
module.exports = {"root":"BlogAuthor-module--root--L-5DP","header":"BlogAuthor-module--header--1bSEL"};